<template>
  <el-tabs class="con-wrap" v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label name></el-tab-pane>
    <el-tab-pane label="所有用户" name="AllUser">
      <user-list></user-list>
    </el-tab-pane>
    <el-tab-pane style="height:100%" label="组织部门" name="second">
      <org-dept></org-dept>
    </el-tab-pane>
    <el-tab-pane style="height:100%" label="角色" name="third">
      <role></role>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import UserList from "./components/UserList.vue"
import OrgDept from "./components/OrgDept.vue"
import role from "./components/role.vue"
export default {
  components: {
    UserList,
    OrgDept,
    role,
  },
  data() {
    return {
      activeName: "AllUser",
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    },
  },
}
</script>
<style lang="scss" scoped>
.con-wrap /deep/ {
  height: calc(100% - 40px);
  overflow: auto;
  .el-tabs__header {
    background: #fff;
    margin-bottom: 20px;
  }
  #tab-0 {
    padding: 0;
    height: 0;
  }
  .el-tabs__content {
    background: #fff;
    height: calc(100% - 60px);
    overflow-y: auto;
  }
}
</style>
